import { useContext } from "react"
import { DESC } from "helpers/sorts"
import { useFactorViewDashboardMetrics } from "helpers/metrics/hooks"
import { INSTRUMENTS } from "connected-components/dashboard/helpers"
import { useTemplateGatherers } from "connected-components/dashboard/hooks/use-template-gatherers"
import ContributorsDataIntegrator from "gatherers/contributors-data-integrator"
import ContributorsTable from "renderers/contributors-datagrid"
import { useAnalytics } from "connected-components/analytics"
import { useFactorsViewTableHandlers } from "../../hooks/use-factors-view-table-handlers"
import { BETA_INSTRUMENT_SHAPE, BETA_FIELDS_SHAPE, FACTORS_VIEW_COMMON_PROPS } from "../../prop-types"

export default function FactorsBetaView({ context, instrumentsWithMetadata, instrumentColumns, betaFields, betaInstrument }) {
  const { base, sortMetricId, setSortMetricId, sortDirection, setSortDirection, selectedTableLevels, setSelectedTableLevels, isEndVsStartDateComparison } = useContext(context)

  const analytics = useAnalytics()
  const { handleSortChanged, handleTableNavigationChanged } = useFactorsViewTableHandlers({ track: analytics.track })

  const gatherers = useTemplateGatherers(context, "factorBeta", {
    betaInstrument,
    betaFields,
    useCompositionQueries: false,
  })

  const metrics = useFactorViewDashboardMetrics(
    [{ category: "factorBeta" }],
    { instrumentColumns, isActive: !!base, instrumentsWithMetadata, isEndVsStartDateComparison },
  )

  const defaultSortSuffix = INSTRUMENTS[instrumentColumns[0]].suffix

  return <ContributorsDataIntegrator
    gatherers={gatherers}
    metrics={metrics}
    Renderer={ContributorsTable}
    rendererProps={{
      groupByName: "Category",
      defaultSort: {
        path: `beta${defaultSortSuffix}`,
        direction: DESC,
      },
      disableCategories: true,
      classes: "factors-table",
      idLabel: "Factor",
      hidePagination: true,
      includeDrilldownArrows: true,
      downloadKey: "factors.beta",
      downloadName: "Factors - Beta",
      sortMetricId,
      onSortMetricIdChange: setSortMetricId,
      sortDirection,
      onSortDirectionChange: setSortDirection,
      tableNavigationLevels: selectedTableLevels,
      onTableNavigationChange: setSelectedTableLevels,
      onSortChanged: handleSortChanged,
      onTableNavigationChanged: handleTableNavigationChanged,
      context,
    }}
  />
}

FactorsBetaView.propTypes = {
  ...FACTORS_VIEW_COMMON_PROPS,
  betaFields: BETA_FIELDS_SHAPE.isRequired,
  betaInstrument: BETA_INSTRUMENT_SHAPE.isRequired,
}
